var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Address",
    clipPath: "url(#clip0_2437_87877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13967 3.13967 0 7 0C10.8603 0 14 3.13967 14 7C14 10.8603 10.8603 14 7 14C3.13967 14 0 10.8603 0 7ZM0.7 7C0.7 10.4741 3.5259 13.3 7 13.3C10.4741 13.3 13.3 10.4741 13.3 7C13.3 3.5259 10.4741 0.7 7 0.7C3.5259 0.7 0.7 3.5259 0.7 7ZM5.66965 5.5125L10.3441 3.18692L10.3461 3.18692C10.4794 3.11993 10.6421 3.14659 10.7488 3.25323C10.8554 3.35851 10.8814 3.5212 10.8151 3.65587L8.4895 8.3303C8.45669 8.39797 8.40064 8.45403 8.33228 8.48752L3.65785 10.8131C3.60864 10.8377 3.55463 10.85 3.50199 10.85C3.41039 10.85 3.31947 10.8131 3.25316 10.7468C3.14652 10.6415 3.12054 10.4788 3.18685 10.3442L5.51243 5.66973C5.54524 5.60205 5.60129 5.546 5.66965 5.5125ZM4.27933 9.72202L7.58375 8.07805L5.9233 6.4176L4.27933 9.72202ZM6.41755 5.92475L8.078 7.5852L8.07876 7.58595L9.72348 4.28003L6.41755 5.92475Z",
    fill: "#767A7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_87877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browser_icon.c481b103447927b7afd8aa116de71909.svg";
export { ForwardRef as ReactComponent };